// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","transparent":"Button_transparent__puDsp","rounded":"Button_rounded__-qIj8","link":"Button_link__vM+72","textOnly":"Button_textOnly__hA5td"};